import React from 'react';
import './search.css';
import { useDispatch, useSelector } from "react-redux";
import { currentSubscriptionAction, searchAction } from "../../redux/rootReducer";
import { CURRENT_SUBSCRIPTION_INITIAL } from "../../redux/initialStateConstant";

const Search = () => {
    const dispatch = useDispatch();
    const search = useSelector(state => state.search);

    return (
        <div className={ 'search' }>
            {
                search.length ? <i className="search__clear" onClick={ () => {
                    dispatch(searchAction(''));
                    dispatch(currentSubscriptionAction(CURRENT_SUBSCRIPTION_INITIAL));
                } }/> : false
            }
            <input type="text" className="search__input input" placeholder={ 'Поиск' }
                onInput={ event => dispatch(searchAction(event.target.value)) }
                value={ search }
            />
        </div>
    );
};

export default Search;